<template>
  <div>
    <div class="mb-15" v-if="pageControl.showHint">
      <span class="text-red"
        >請按保單條款，選取適合的保障公式，輸入參數後按下方的新增按鍵</span
      >
    </div>
    <div class="mb-15">
      <select
        v-if="showParentItem"
        class="form-control form-control-inline form-wide w-130"
        v-model="pageControl.parentCategoryName"
        @change="parentCategoryChange()"
      >
        <option
          v-for="item in pageControl.coverageParentCategories"
          :key="item"
          :value="item"
        >
          {{ item }}
        </option>
      </select>
      <select
        class="form-control form-control-inline form-wide w-100"
        :class="{ 'is-invalid': validate.isDutyErr }"
        v-model="form.duty"
      >
        <option
          v-for="item in pageControl.coverageTargets"
          :key="item.value"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
      <select
        class="form-control form-control-inline form-wide ml-50 w-100"
        :class="{ 'is-invalid': validate.isPrdErr }"
        v-model="form.annual"
      >
        <option value="all">所有年期</option>
        <option
          v-for="item in pageControl.coverageAnnuals"
          :key="item.value"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
      <span
        class="ml-50 lh-40"
        v-if="pageControl.showScheme && !pageControl.showRadioButtons"
        >計畫：</span
      >
      <select
        class="form-control form-control-inline form-wide w-100"
        v-if="pageControl.showScheme && !pageControl.showRadioButtons"
        v-model="form.sche_nm"
        @change="schemeChange($event.target.selectedIndex)"
      >
        <option value="all">所有計畫</option>
        <option
          v-for="item in pageControl.schemeItems"
          :key="item.text"
          :value="item.text"
        >
          {{ item.text }}
        </option>
      </select>
      <span class="ml-50 lh-40" v-if="pageControl.showPrimaryCategory"
        >保障項目類別：</span
      >
      <select
        v-if="pageControl.showPrimaryCategory"
        class="form-control form-control-inline form-wide w-130"
        :class="{ 'is-invalid': validate.isPrimaryCategoryErr }"
        v-model="pageControl.parentCategoryName"
        @change="parentCategoryChange()"
      >
        <option value="">請選擇</option>
        <option
          v-for="item in pageControl.coverageParentCategories"
          :key="item"
          :value="item"
        >
          {{ item }}
        </option>
      </select>
      <span class="ml-50 lh-40" v-if="pageControl.showCoverageItems"
        >保障項目：</span
      >
      <div 
        v-if="pageControl.showCoverageItems"
        class="w-325 d-inline-block"
      >
        <!-- LICRMPA-4857: 當母類別或 categoryId 動態改變時，強迫 v-select 元件重新渲染選中文字，解決畫面卡在「請選擇」的問題 -->
        <v-select
          :key="pageControl.parentCategoryName + '-' + form.categoryId"
          :class="{ 'is-invalid': validate.isCategoryIdErr }"
          :options="filterCoverageItems"
          :reduce="(item) => item.value"
          label="text"
          placeholder="請選擇"
          v-model="form.categoryId"
        >
          <div slot="no-options">沒有資料可供選擇 !</div>
        </v-select>
      </div>
      <span class="ml-50 lh-40" v-if="pageControl.showBenefitTypes"
        >給付方式：</span
      >
      <select
        class="form-control form-control-inline form-wide w-130"
        v-if="pageControl.showBenefitTypes"
        v-model="form.benefitTypeId"
      >
        <option
          v-for="item in this.pageControl.coverageBenefitTypes"
          :key="item.value"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
      <select
        class="form-control form-control-inline form-wide ml-50 w-325"
        :class="{ 'is-invalid': validate.isCategoryIdErr }"
        v-if="pageControl.showSecondaryCategory"
        v-model="form.categoryId"
      >
        <option
          v-for="item in this.pageControl.coverageCategories"
          :key="item.value"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
      <select
        class="form-control form-control-inline form-wide ml-50 w-325"
        v-if="pageControl.showGoodWishList"
        v-model="form.goodWishId"
        @change="goodWishIdChange()"
      >
        <option
          v-for="item in this.pageControl.coverageGoodWishList"
          :key="item.value"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
    <div class="row" v-if="pageControl.showRadioButtons">
      <div class="radio radio-inline ml-15">
        <input
          type="radio"
          id="showType-1"
          v-model="form.othersId"
          value="1"
          @change="othersIdChange()"
        />
        <label for="showType-1">單行型公式</label>
      </div>
      <div class="radio radio-inline">
        <input
          type="radio"
          id="showType-2"
          v-model="form.othersId"
          value="2"
          @change="othersIdChange()"
        />
        <label for="showType-2">多行型公式</label>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePageCondition",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {
          pageName: "",
          coverageParentCategories: [],
          coverageTargets: [],
          coverageAnnuals: [],
          schemeItems: [],
          coverageCategories: [],
          coverageGoodWishList: [],
          showScheme: false,
          showHint: false,
          showCoverageItems: true,
          showGoodWishList: false,
        };
      },
    },
    form: {
      type: Object,
      default: () => {
        return {
          conditionId: "",
          duty: 1,
          year_type: 0,
          auunal: "all",
          prd: 0,
          parentCategoryName: "",
          categoryId: "",
          sche_amt: 0,
          sche_nm: "all",
        };
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {
          isDutyErr: false,
          isPrdErr: false,
          isCategoryIdErr: false,
        };
      },
    },
  },
  computed: {
    showParentItem() {
      return (
        this.pageControl.coverageParentCategories.length > 1 &&
        this.pageControl.pageName !== "生存保險金" &&
        this.pageControl.pageName !== "其他保障"
      );
    },
    filterCoverageItems() {
      return this.pageControl.coverageCategories.filter(
        (item) => item.parent == this.pageControl.parentCategoryName
      );
    },
    categoryText() {
      if (this.pageControl.parentCategoryName === "其他保障"){
        this.form.categoryId = ''
      } else {
        // LICRMPA-4857: 先將過濾出來的結果存在 found 陣列中
        const found = this.filterCoverageItems.filter(
          (obj) => obj.value == this.form.categoryId
        );
        // LICRMPA-4857 防呆保護：確定真的有搜尋到資料 (found.length > 0) 才取出文字；沒找到則傳回空字串，防止存取 undefined.text 導致網頁白屏崩潰
        return this.form.categoryId && found.length
          ? found[0].text
          : "";
      }
    },
  },
  watch: {
    "pageControl.parentCategoryName": {
      immediate: true,
      deep: true,
      handler(value) {
        if (!value) {
          this.reset();
        }
      },
    },
    "form.annual"(value) {
      if (value == "all") {
        this.form.prd = 0;
        this.form.year_type = 0;
      } else if (value.includes("年期")) {
        this.form.prd = value.replace("年期", "");
        this.form.year_type = 1;
      } else if (value.includes("歲")) {
        this.form.prd = value.replace("歲", "");
        this.form.year_type = 2;
      }
    },
    "pageControl.coverageCategories": {
      immediate: true,
      deep: true,
      handler() {
        //修正reset於初始化時有機會抓不到此陣列的問題
        this.reset();
      },
    },
    "pageControl.coverageGoodWishList": {
      immediate: true,
      deep: true,
      handler() {
        //修正reset於初始化時有機會抓不到此陣列的問題
        this.reset();
      },
    },
    categoryText: {
      handler: function (value) {
        if (value === "生命末期保險金") {
          this.pageControl.showBenefitTypes = true;
        } else {
          this.pageControl.showBenefitTypes = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    schemeChange(i) {
      if (i == 0) {
        this.form.sche_amt = 0;
      } else {
        this.form.sche_amt = this.pageControl.schemeItems[i - 1].value;
      }
    },
    parentCategoryChange() {
      if (this.filterCoverageItems.length > 0) {
        this.form.categoryId = this.filterCoverageItems[0].value;
      } else {
        this.form.categoryId = "";
      }
    },
    goodWishIdChange() {
      if (this.form.goodWishId == 1) {
        this.pageControl.pageBlock = ["periodGoodwish", "formulaGoodwish", "maxSingle"];
        this.form.guaranteepayage = "";
      } else {
        this.pageControl.pageBlock = ["periodMulti", "formulaMulti", "maxSingle"];
      }
    },
    othersIdChange() {
      if (this.form.othersId == 1) {
        this.pageControl.pageBlock = ["periodSingle", "formulaSingle", "maxCustom"];
        this.form.guaranteepayage = "";
      } else {
        this.pageControl.pageBlock = ["periodMulti", "formulaMulti", "maxCustom"];
      }
    },
    //針對此元件重置值
    reset() {
      if (!this.pageControl.parentCategoryName) {
        if (this.pageControl.pageName === "其他保障") {
          this.pageControl.parentCategoryName = "其他保障";
        } else {
          this.pageControl.parentCategoryName =
            this.pageControl.coverageParentCategories[0];
        }
      }
      if (this.filterCoverageItems.length > 0 && this.pageControl.parentCategoryName !== "其他保障") {
        // 點擊編輯或已選定 categoryId 時，若該 categoryId 包含於現有選單列表內則保留，不強行覆蓋
        const hasCurrent = this.filterCoverageItems.some(item => item.value === this.form.categoryId);
        if (!hasCurrent) {
          this.form.categoryId = this.filterCoverageItems[0].value;
        }
      }
      if (this.pageControl.coverageGoodWishList.length > 0) {
        this.form.goodWishId = this.pageControl.coverageGoodWishList[0].value;
      }
    },
  },
};
</script>
